import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminAPI } from '../../shared/api/admin-api';

interface Order {
  id: number;
  order_code: string;
  customer_name: string;
  total: number;
  status: string;
  created_at: string;
}

function RecentOrders() {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const ordersData = await AdminAPI.get('orders') as Order[];
      setOrders(ordersData.slice(0, 3));
    } catch (error) {
      console.error('Erro ao carregar pedidos:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusClass = (status: string) => {
    const statusMap: { [key: string]: string } = {
      pending: 'pending',
      confirmed: 'processing',
      shipped: 'processing',
      delivered: 'delivered',
      cancelled: 'pending',
    };
    return statusMap[status] || 'pending';
  };

  const getStatusText = (status: string) => {
    const statusMap: { [key: string]: string } = {
      pending: 'Pendente',
      confirmed: 'Processando',
      shipped: 'Processando',
      delivered: 'Entregue',
      cancelled: 'Cancelado',
    };
    return statusMap[status] || status;
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffDays = Math.ceil((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays === 1) {
      return `Hoje, ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
    } else if (diffDays === 2) {
      return `Ontem, ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
    }
    return date.toLocaleDateString('pt-BR');
  };

  if (loading) {
    return (
      <section className="recent-section">
        <div>Carregando pedidos...</div>
      </section>
    );
  }

  return (
    <section className="recent-section">
      <div className="section-header">
        <h2 className="section-title">Pedidos Recentes</h2>
        <Link to="/admin/pedidos" className="see-all">Ver todos</Link>
      </div>
      <div className="orders-list">
        {orders.length === 0 ? (
          <div>Nenhum pedido encontrado</div>
        ) : (
          orders.map((order) => (
            <div key={order.id} className="order-item">
              <div className="order-info">
                <div className="order-id">#{order.order_code || order.id}</div>
                <div className="order-customer">{order.customer_name}</div>
                <div className="order-date">{formatDate(order.created_at)}</div>
              </div>
              <div className={`order-status ${getStatusClass(order.status)}`}>
                {getStatusText(order.status)}
              </div>
              <div className="order-value">
                R$ {parseFloat(String(order.total || 0)).toFixed(2).replace('.', ',')}
              </div>
            </div>
          ))
        )}
      </div>
    </section>
  );
}

export default RecentOrders;

